import 'jquery-ajax-unobtrusive';
import '../../../scss/sites/e-learning/e-learning-style.scss';
import Header from '@png/npm-header';
import SelectDropdown from '@png/npm-select-dropdown';
import SvgIcon from '@png/npm-svg-icon';
import AddressLookup from '../../modules/address-lookup';
import ClearCache from '../../modules/clear-cache';
import CookieBar from '../../modules/cookie-bar';
import FilterTags from '../../modules/filter-tags';
import FloatingLabels from '../../modules/floating-labels';
import Incrementer from '../../modules/incrementer';
import LightGallery from '../../modules/light-gallery';
import Pagination from '../../modules/pagination';
import Sticky from '../../modules/sticky';
import Video from '../../modules/video';
import Toast from '../../modules/toast';
import Popup from '../../modules/popup';
import SmoothScroll from '../../modules/smooth-scroll';
import OrderHistory from '../../modules/order-history';
import MacroUseButtonUrl from '../../modules/macro-use-button-url';
import ReadMoreLess from '../../modules/read-more-less';
import CourseSelector from '../../modules/course-selector';
import RealTimePrice from '../../modules/catalog/realtime-price';

document.addEventListener('DOMContentLoaded', () => {
  const modules = [
    new MacroUseButtonUrl({
      rowClickable: ['row-10b', 'row-10a']
    }),
    new AddressLookup(),
    new FilterTags(),
    new FloatingLabels(),
    new ClearCache(),
    new CookieBar(),
    new Header({
      desktopMenuBreakpoint: 992,
      openUrlOnToggle: false
    }),
    new Incrementer(),
    new LightGallery(),
    new Pagination(),
    new Popup(),
    new ReadMoreLess({
      dots: true
    }),
    new SelectDropdown(),
    new Sticky({
      velocity: 500
    }),
    new SvgIcon(),
    new Toast({
      duration: 3000,
      close: true
    }),
    new SmoothScroll(),
    new Video(),
    new OrderHistory(),
    new CourseSelector(),
    new RealTimePrice()
  ];

  modules.forEach(module => {
    if (module && module.init) {
      module.init();
    }
  });
});
